import {
  Component,
  ChangeDetectionStrategy,
  Input,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mb-expandable-copy',
  templateUrl: './expandable-copy.component.html',
  styleUrls: ['./expandable-copy.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class ExpandableCopyComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @Input() text = '';

  @ViewChild('copyWrapper', { static: true }) copyWrapper!: ElementRef;

  public showAll = false;
  public isExpandable = false;

  ngAfterViewInit(): void {
    const el = this.copyWrapper.nativeElement;
    this.isExpandable = el.scrollHeight > el.clientHeight;
    this.cdr.detectChanges();
  }
}
